import { Button, Container, Grid, GridColumn, Heading, Icon, Text } from 'telia-front-react';
import { observer } from 'mobx-react';
import * as React from 'react';
import useStores from '../stores/UseStores';

const RegistrationSuccessNotice = observer((): React.JSX.Element => {
  const {
    routeStore,
    translateStore: { translate },
    emailRegisterStore,
  } = useStores();
  const { homePageWithParams: url } = routeStore;

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>, url: string) => {
    event.preventDefault();
    routeStore.route(url);
    emailRegisterStore.initDefaultValues();
  };

  return (
    <Container>
      <Grid align={['center-xs']} className="text-center">
        <GridColumn width={['xs-10', 'md-8', 'lg-6']}>
          <Text>
            <Icon modifiers="#check-round" size="lg" className="text-success" />
            <Heading level={1} className="h3">
              {translate('email_register.validation_header')}
            </Heading>
            <p>
              {translate('email_register.validation_sent', { email: emailRegisterStore.emailRegisterCredentials.email })}{' '}
              {translate('email_register.validation_instructions')}
            </p>
            <Button url={url} onClick={(event) => handleClick(event, url)} text={translate('email.register.continue')} variant="secondary" />
          </Text>
        </GridColumn>
      </Grid>
    </Container>
  );
});

export default RegistrationSuccessNotice;
